import { View } from "react-native";
import Profile from "src/components/Profile";
import ProfilePicture from "src/components/ProfilePicture";
import { paddingLarge, paddingMedium, paddingSmall } from "src/styles/spacing";
import { Image, Link, Text } from "src/swsh-native";
import { CommentsThreadRowType } from "../../types";

const Size = 160;
const BorderRadius = 16;
const ImagePadding = 4;
const CommentPhotoHeader = ({ item }: { item: CommentsThreadRowType.PhotoHeader }) => {
	return (
		<View
			style={{
				alignItems: "center",
				flexDirection: "column",
				rowGap: paddingMedium,
				marginTop: paddingLarge,
			}}
		>
			<Link
				href={item.photoHeader.href}
				style={{
					padding: ImagePadding,
					backgroundColor: "white",
					borderRadius: BorderRadius,
				}}
			>
				<Image
					alt="Thread photo"
					src={item.photoHeader.imageUrl}
					dim={{
						width: Size,
						height: Size,
					}}
					style={{
						borderRadius: BorderRadius - ImagePadding,
					}}
				/>
			</Link>
			<View
				style={{
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "center",
					columnGap: paddingSmall,
				}}
			>
				<Profile
					userId={item.photoHeader.ownerId}
					style={{
						flexDirection: "row",
						alignItems: "center",
						columnGap: paddingSmall,
					}}
					renderContent={({ firstName, userId }) => (
						<>
							<ProfilePicture userId={userId} size={20} />
							<Link href={`/user_/${userId}`}>
								<Text semibold>{firstName}</Text>
							</Link>
						</>
					)}
				/>
				<Text>uploaded</Text>
			</View>
		</View>
	);
};
export default CommentPhotoHeader;
